import { createSaveEntityAction } from '../generic/entityAction';

export const ENROLLMENT_SEARCH = 'ENROLLMENT_SEARCH';

export default {
    searchEnrollments: createSaveEntityAction(() => '/api/enrollments/search', ENROLLMENT_SEARCH),
};